/* unplugin-vue-components disabled */import script from "./tipCard.vue?vue&type=script&setup=true&lang=js"
export * from "./tipCard.vue?vue&type=script&setup=true&lang=js"

import "./tipCard.vue?vue&type=style&index=0&id=1500d98e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1500d98e"]])

export default __exports__